/* istanbul ignore file */
import { asyncRetryWithTimeout, throwDevError } from '@/src/general/utils/errors'

const timeoutMessage = 'navigator.serviceWorker.ready - timeout'

export const getSwRegistration = async () => {
  try {
    return await asyncRetryWithTimeout(() => navigator.serviceWorker?.ready, {
      attempts: 3,
      attemptTime: 3000,
      delayBetweenAttempts: 2000,
      timeoutMessage,
    })
  } catch (error) {
    if (typeof error === 'object' && error && 'message' in error && error.message === timeoutMessage) {
      console.debug('No service worker registration found.')
    } else {
      throwDevError('An error occurred while trying to retrieve a service worker registration', { cause: error })
    }
    return null
  }
}
